import React, { FC } from 'react';
import { Header } from '../components';

const HeaderContainer: FC = () => (
  <Header>
    <Header.Title>Hacker news</Header.Title>
  </Header>
);

export default HeaderContainer;
